angular.module('acme.common.service.eventApi', [
  'acme.common.service.calendar',
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('EventApiService', [
  '$http',
  'CalendarService',
  'QueryStringBuilderFactory',
  'ApiVersionFactory',
  function EventApiService(
    $http,
    CalendarService,
    QueryStringBuilderFactory,
    ApiVersionFactory
  ) {

    return {

      service: '',

      init: function (endpoint) {
        this.service = endpoint + '/event/instances';
        this.coupon.service = endpoint + '/event/instances/coupon';
        this.config.service = endpoint + '/event/instances/config';
        this.statements.service = endpoint + '/event/instances/statements';
        return this;
      },

      /**
       * Get all instance summaries between two dates
       *
       * @param props
       * @returns {*}
       */
      list: function(props) {

        var q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'saleChannel', 'endTime', 'pageSize', 'page', 'sortField', 'templateId', 'sortDirection', 'search', 'resourceRequestFilter', 'filter']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + '/summaries' + q,
          timeout: 60000,
          cache: props.cache
        });

      },

      getEventsByTemplateId: function(templateId) {
        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + '/excerpts?templateId=' + templateId,
          timeout: 60000
        });
      },

      /**
       * search all instance summaries between two dates
       *
       * @param props
       * @returns {*}
       */
      search: function(props) {

        var pagination = {
          page: props.page,
          pageSize: props.pageSize,
          sortDirection: props.sortDirection,
          sortField: props.sortField
        };

        return $http({
          method: 'post',
          url: this.service.replace(/v1/, 'v2') + '/summaries',
          timeout: 60000,
          cache: props.cache,
          data: {
            startTime: props.startTime,
            endTime: props.endTime,
            templateId: props.templateId,
            saleChannel: props.saleChannel,
            resourceRequestFilter: props.resourceRequestFilter,
            filter: props.filter,
            search: props.search,
            pagination: pagination,
            customFields: props.customFields,
            states: props.states
          }
        });

      },

      detail: function(id, props) {
        var q = new QueryStringBuilderFactory({
          props: props || {},
          fields: {
            optional: ['membershipId', 'membershipCategoryId']
          }
        });

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + '/' + id + q.query
        });
      },

      canceled: function(startTime, endTime, props){

        var q = '';

        if (startTime) {
          props.startTime = CalendarService.toISO8601(startTime);
        }

        if (endTime) {
          props.endTime = CalendarService.toISO8601(endTime);
        }

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'endTime', 'pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + '/cancelled' + q,
          timeout: 60000
        });

      },

      /**
       * Get all instance data between two dates
       *
       * @param startTime
       * @param endTime
       * @returns {*}
       */
      gantt: function(startTime, endTime) {

          var queries = [],
              q = '';

          if (startTime) {
              queries.push('startTime=' + CalendarService.toISO8601(startTime));
          }

          if (endTime) {
              queries.push('endTime=' + CalendarService.toISO8601(endTime));
          }

          if (queries.length > 0) {
              q = '?'+queries.join('&');
          }

          return $.ajax({
              method: 'get',
              url: this.service.replace(/v1/, 'v2') + '/gantt' + q,
              timeout: 60000
          });

      },

      /**
       * Get event instances based on template id
       *
       * Accepts:
       * {
       *   templateId: {String}
       *   startTime: {ISO8601 Date String}
       *   endTime: {ISO8601 Date String}
       * }
       * @param props
       * @returns {*}
       */
      schedules: function(props) {

        var queries = [],
          q = '';

        if (props.templateId) {
          queries.push('templateId=' + props.templateId);
        }

        if (props.startTime) {
          queries.push('startTime=' + CalendarService.toISO8601(props.startTime));
        }

        if (props.endTime) {
          queries.push('endTime=' + CalendarService.toISO8601(props.endTime));
        }

        if (queries.length > 0) {
          q = '?'+queries.join('&');
        }

        return $.ajax({
          method: 'get',
          url: this.service.substring(0, this.service.length - 1) + q,
          timeout: 60000
        });
      },

      exceptions: function(eventTemplateId, props) {
        var q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/,'v2') + '/' + eventTemplateId + '/diff' + q,
          timeout: 60000
        });
      },

      createOffSchedule: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({url: this.service, version: 'v2'}),
          data: {
            id: props.eventId,
            templateId: props.id,
            scheduleId: props.scheduleId,
            originalFields: props.originalFields,
            name: props.name,
            description: props.description,
            shortDescription: props.shortDescription,
            colorCategory: props.colorCategory,
            emailConfirmationMessage: props.emailConfirmationMessage,
            emailCancellationMessage: props.emailCancellationMessage,
            capacity: props.capacity,
            startTime: props.startTime,
            endTime: props.endTime,
            flexPays: props.flexPays,
            resources: props.resources,
            resourceDetails: props.resourceDetails,
            priceList: props.priceList,
            rebookingFee: props.rebookingFee,
            ticketConfig: props.ticketConfig,
            customFields: props.customFields,
            offSchedule: true,
            orderRequestId: props.orderRequestId,
            organization: props.organization
          }
        });
      },

      createFromPrivateSchedule: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({url: this.service, version: 'v2'}),
          data: {
            id: props.eventId,
            templateId: props.id,
            scheduleId: props.scheduleId,
            originalFields: props.originalFields,
            name: props.name,
            description: props.description,
            shortDescription: props.shortDescription,
            colorCategory: props.colorCategory,
            emailConfirmationMessage: props.emailConfirmationMessage,
            emailCancellationMessage: props.emailCancellationMessage,
            capacity: props.capacity,
            startTime: props.startTime,
            endTime: props.endTime,
            flexPays: props.flexPays,
            resources: props.resources,
            resourceDetails: props.resourceDetails,
            priceList: props.priceList,
            rebookingFee: props.rebookingFee,
            ticketConfig: props.ticketConfig,
            customFields: props.customFields,
            offSchedule: false,
            orderRequestId: props.orderRequestId,
            organization: props.organization,
            salesChannels: props.salesChannels
          }
        });
      },

      updateOffSchedule: function(props) {
        var av = new ApiVersionFactory();

        if (props) {
          props.offSchedule = true;
        }

        return $http({
          method: 'put',
          url: av.init({url: this.service, version: 'v2'}),
          data: props
        });
      },

      removeOffSchedule: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({url: (this.service + '/' + id), version: 'v2'})
        });
      },

      config: {
        service: '',

        list : function(configId) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({
              url: this.service + '/' + configId,
              version: 'v2'
            })
          });
        }
      },

      statements: {

        service: '',

        /**
         * Get List of Event Statements between two dates
         *
         * @param props
         * @returns {*}
         */
        list: function(props) {

          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['startTime', 'saleChannel', 'endTime', 'pageSize', 'page', 'sortField', 'templateId', 'sortDirection', 'search', 'resourceRequestFilter', 'filter', 'type']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q,
            timeout: 60000,
            cache: props.cache
          });

        },

        /**
         * search all instance summaries between two dates
         *
         * @param props
         * @returns {*}
         */
        search: function(props) {

          var pagination = {
            page: props.page,
            pageSize: props.pageSize,
            sortDirection: props.sortDirection,
            sortField: props.sortField
          };

          return $http({
            method: 'post',
            url: this.service.replace(/v1/, 'v2'),
            timeout: 60000,
            cache: props.cache,
            data: {
              startTime: props.startTime ,
              saleChannel: props.saleChannel,
              endTime: props.endTime,
              pagination: pagination,
              templateId: props.templateId,
              search: props.search,
              resourceRequestFilter: props.resourceRequestFilter,
              filter: props.filter,
              type: props.type,
              customFields: props.customFields,
              states: props.states
            }
          });

        }
      },

      coupon: {
        service: '',

        priceLists: function(props) {
          var av = new ApiVersionFactory(),
              qs;

          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['eventIds'],
              optional: ['validate']
            }
          });

          return $http({
            method: 'get',
            url: av.init({url: this.service + '/all/pricelists' + qs.query, version: 'v2'})
          });
        }
      }

    };

}]);